import ReactjsPlayer from './ReactjsPlayer';
import GrindPlayer from './GrindPlayer';
import PlayerContext from './PlayerContext';
import PlayerSkin from './PlayerSkin';

ReactjsPlayer.GrindPlayer = GrindPlayer;
ReactjsPlayer.PlayerContext = PlayerContext;
ReactjsPlayer.PlayerSkin = PlayerSkin;

export default ReactjsPlayer;
